export const changeLanguageAction = (payload) => ({
    type: "toggle/CHANGE_LANGUAGE",
    payload
})